// import React from "react";
import {
  // FaTwitter,
  FaLinkedin,
  // FaGithub,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaWhatsapp,
  // FaTelegram,
  FaTelegramPlane,
  // FaMailBulk,
  // FaMapPin,
} from "react-icons/fa";
// import { FaMailchimp, FaPhone } from "react-icons/fa6";
import { CiMail } from "react-icons/ci";
import { MdEmail } from "react-icons/md";

function Footer() {
  return (
    <footer className="bg-[#000000] text-gray-300 py-14 border-t border-gray-900">

      <div className="max-w-7xl mx-auto px-5">

        {/* Top Grid */}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 mb-14">

          {/* Company Info */}

          <div className="lg:col-span-2">

            <div className="flex items-center gap-3 mb-4">
              <img
                src="./img/CML_LOGO.png"
                alt="logo"
                className="w-11 h-11 bg-white rounded-full p-1"
              />
              <h2 className="text-white text-xl font-semibold">
                Chain Magician Lab
              </h2>
            </div>

            <p className="text-sm leading-relaxed mb-6 text-gray-400 max-w-md break-words">
              Chain Magician Lab is a blockchain innovation company building
              secure decentralized applications, smart contracts, AI
              integrations and Web3 solutions for startups and enterprises.
            </p>

            {/* Social Icons */}

            <div className="flex gap-4 text-2xl">

              <a
                href="https://wa.me/916393561379?text=Hello%20I'm%20looking%20for%20software%20development%20services.%20Please%20share%20details."
                className="hover:text-white transition transform hover:scale-110"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp />
              </a>

              <a
                href="https://www.linkedin.com/in/anmolsingh-chainmagicianlab"
                className="hover:text-white transition transform hover:scale-110"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin />
              </a>

              {/* <a
                href="#"
                className="hover:text-white transition transform hover:scale-110"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaPhone />
              </a> */}

              <a
                href="https://instagram.com/chainmagicianlab"
                className="hover:text-white transition transform hover:scale-110"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
                <a
                href="https://t.me/chainmagicianlab"
                className="hover:text-white transition transform hover:scale-110"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTelegramPlane />
              </a>
                  <a
                href="mailto:connnect@chainmagicianlab.com"
                className="hover:text-white transition transform hover:scale-110"
                target="_blank"
                rel="noopener noreferrer"
              >
                <CiMail />
              </a>

            </div>

          </div>

          {/* Services */}

          <div>
            <h3 className="text-white font-semibold mb-5">Services</h3>

            <ul className="space-y-3 text-sm">

              {/* <li className="hover:text-white cursor-pointer">
                Smart Contract Development
              </li> */}

              <li className="hover:text-white cursor-pointer">
                Web3 Application Development
              </li>

              <li className="hover:text-white cursor-pointer">
                Blockchain Consulting
              </li>

              <li className="hover:text-white cursor-pointer">
                AI Integration
              </li>

              <li className="hover:text-white cursor-pointer">
                DeFi Platform Development
              </li>

            </ul>
          </div>

          {/* Resources */}

          <div>
            <h3 className="text-white font-semibold mb-5">Resources</h3>

            <ul className="space-y-3 text-sm">

              <li className="hover:text-white cursor-pointer">Blog</li>
              {/* <li className="hover:text-white cursor-pointer">Documentation</li> */}
              <li className="hover:text-white cursor-pointer">Case Studies</li>
              <li className="hover:text-white cursor-pointer">Help Center</li>
              <li className="hover:text-white cursor-pointer">Community</li>

            </ul>
          </div>

          {/* Contact Info */}

          <div>

            <h3 className="text-white font-semibold mb-5">
              Contact Info
            </h3>

            <ul className="space-y-4 text-sm">

              {/* Address */}

              <li className="flex items-start gap-3">

                <FaMapMarkerAlt className="text-green-500 mt-1 shrink-0" />

                <a
                  href="https://maps.google.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition"
                >
                  Chain Magician Lab Pvt Ltd <br />
                  Shantipuram, Phaphamau <br />
                  Uttar Pradesh, India 211013
                </a>

              </li>

              {/* Phone */}

              <li className="flex items-center gap-3">

                <FaPhoneAlt className="text-green-500 shrink-0" />

                <a
                  href="tel:+916393561379"
                  className="hover:text-white transition"
                >
                  +91 6393561379
                </a>

              </li>

              {/* Email */}

              <li className="flex items-center gap-3">

                <MdEmail className="text-green-500 shrink-0" />

                <a
                  href="mailto:connect@chainmagicianlab.com"
                  className="hover:text-white transition break-all"
                >
                  connect@chainmagicianlab.com
                </a>

              </li>

              {/* WhatsApp */}

              {/* <li className="flex items-center gap-3">

                <FaWhatsapp className="text-green-500 shrink-0" />

                <a
                  href="https://wa.me/916393561379"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition"
                >
                  Chat on WhatsApp
                </a>

              </li> */}

            </ul>

          </div>

        </div>

        {/* Bottom Bar */}

        <div className="border-t border-gray-700 pt-6 flex flex-col md:flex-row justify-between items-center text-sm gap-4">

          <p className="text-center md:text-left">
            © {new Date().getFullYear()} Chain Magician Lab. All rights reserved.
          </p>

          <div className="flex flex-wrap justify-center gap-6">

            <span className="hover:text-white cursor-pointer">
              Privacy Policy
            </span>

            <span className="hover:text-white cursor-pointer">
              Terms of Service
            </span>

            <span className="hover:text-white cursor-pointer">
              Cookies
            </span>

          </div>

        </div>

      </div>

    </footer>
  );
}

export default Footer;